var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('section',{staticClass:"article-wrap"},[_c('article',{staticClass:"article"},[_c('nuxt-content',{attrs:{"document":_vm.article}})],1),_vm._v(" "),_c('JoinUs')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }